/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

import { SchemaMarkPlugin } from '../..'

export default {
  __type: 'wysiwyg:schema:mark',
  name: 'strong',
  mark: {
    parseDOM: [
      { tag: 'strong' },
      // This works around a Google Docs misbehavior where
      // pasted content will be inexplicably wrapped in `<b>`
      // tags with a font-weight normal.
      {
        tag: 'b',
        getAttrs: (node: HTMLElement) => {
          return node.style.fontWeight != 'normal' && null
        },
      },
      {
        style: 'font-weight',
        getAttrs: (value: string) => {
          return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
        },
      },
    ],
    toDOM() {
      return ['strong']
    },
  },
} as SchemaMarkPlugin
